import React from "react";
import { informations } from "../data/SiteData";
function Hero(props) {
  return (
    <section id="hero" class="d-flex align-items-center">
      <div
        class="container position-relative"
        data-aos="fade-up"
        data-aos-delay="500"
      >
        <h3 style={{ color: "#444444" }}>
          Welcome to{" "}
          <a href="" style={{ color: "#cc1616" }}>
            {informations.title}
          </a>
        </h3>
        <h2>{informations.slogan}</h2>
        <a href="#about" class="btn-get-started scrollto">
          Get Started
        </a>
      </div>
    </section>
  );
}

export default Hero;
